<template>
  <b-modal id="mass-idp-export-modal" :modal-class="`adp-modal`" :body-class="`adp-modal-body`"
           :header-class="`adp-modal-header`" :footer-class="`adp-modal-footer d-flex justify-content-center`"
           @show="onShow">
    <template #modal-title>
      <div class="d-flex">
        <span class="modal-title adp-h2 adp-h2__modal">{{ modalTitle }}</span>
      </div>
    </template>
    <template #modal-header-close>
      <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
    </template>
    <template v-if="!isLoading">
      <div class="adp-modal-row mb-3">
        <label class="adp-p adp-p__grey">{{ $t('modal.idp_export_year') }}</label>
        <my-dropdown :options="IDPYears" :init-selected="selectedYears" :has-select-all="true" :for-modal="true"
                     v-on:my-change="changeYear($event, 'selectedYears')" :localize="false">
        </my-dropdown>
      </div>

      <div class="adp-modal-row mb-3" v-if="exportType === 'idp'">
        <label class="adp-p adp-p__grey">{{ $t('modal.idp_export_tab_type') }}</label>
        <div class="d-flex flex-column">
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="allTypes" :indeterminate="allTypesIndeterminate"
                               @change="checkAllTypes($event)"/>
            </div>
            <div>{{ $t('modal.select_all') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="learning" @change="checkTypes($event, 'learning')"/>
            </div>
            <div>{{ $t('modal.idp_export_learning') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="wish" @change="checkTypes($event, 'wish')"/>
            </div>
            <div>{{ $t('modal.idp_export_wish') }}</div>
          </div>
        </div>
      </div>

      <div class="adp-modal-row mb-3">
        <label class="adp-p adp-p__grey">{{ $t('modal.idp_export_row') }}</label>
        <div class="d-flex flex-column">
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="allRows" :indeterminate="allRowsIndeterminate"
                               @change="checkAllRows($event)"/>
            </div>
            <div>{{ $t('modal.select_all') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="pernumber" @change="checkRows($event, 'pernumber')"/>
            </div>
            <div>{{ $t('modal.idp_export_pernumber') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="fio" @change="checkRows($event, 'fio')"/>
            </div>
            <div>{{ $t('modal.idp_export_fio') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="position" @change="checkRows($event, 'position')"/>
            </div>
            <div>{{ $t('modal.idp_export_position') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="employeeType" @change="checkRows($event, 'employeeType')"/>
            </div>
            <div>{{ $t('modal.idp_export_employee_type') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="reservist" @change="checkRows($event, 'reservist')"/>
            </div>
            <div>{{ $t('modal.idp_export_reservist') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="employeeGroup" @change="checkRows($event, 'employeeGroup')"/>
            </div>
            <div>{{ $t('modal.idp_export_employee_group') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="sex" @change="checkRows($event, 'sex')"/>
            </div>
            <div>{{ $t('modal.idp_export_sex') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="bu" @change="checkRows($event, 'bu')"/>
            </div>
            <div>{{ $t('modal.idp_export_bu') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="department" @change="checkRows($event, 'department')"/>
            </div>
            <div>{{ $t('modal.idp_export_department') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="division" @change="checkRows($event, 'division')"/>
            </div>
            <div>{{ $t('modal.idp_export_division') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="subdivision" @change="checkRows($event, 'subdivision')"/>
            </div>
            <div>{{ $t('modal.idp_export_subdivision') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="orgStructure5" @change="checkRows($event, 'orgStructure5')"/>
            </div>
            <div>{{ $t('modal.idp_export_org_5') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="orgStructure6" @change="checkRows($event, 'orgStructure6')"/>
            </div>
            <div>{{ $t('modal.idp_export_org_6') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="orgStructure7" @change="checkRows($event, 'orgStructure7')"/>
            </div>
            <div>{{ $t('modal.idp_export_org_7') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="orgStructure8" @change="checkRows($event, 'orgStructure8')"/>
            </div>
            <div>{{ $t('modal.idp_export_org_8') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="fired" @change="checkRows($event, 'fired')"/>
            </div>
            <div>{{ $t('modal.idp_export_employee_status') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="supervisor" @change="checkRows($event, 'supervisor')"/>
            </div>
            <div>{{ $t('modal.idp_export_supervisor') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="idpYear" @change="checkRows($event, 'idpYear')"/>
            </div>
            <div>{{ $t('modal.idp_export_idp_year') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="idpStatus" @change="checkRows($event, 'idpStatus')"/>
            </div>
            <div>{{ $t('modal.idp_export_idp_status') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="idpPercent" @change="checkRows($event, 'idpPercent')"/>
            </div>
            <div>{{ $t('modal.idp_export_idp_percent') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="learningGroup" @change="checkRows($event, 'learningGroup')"/>
            </div>
            <div>{{ $t('modal.idp_export_learning_group') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="func" @change="checkRows($event, 'func')"/>
            </div>
            <div>{{ $t('modal.idp_export_function') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="competencies" @change="checkRows($event, 'competencies')"/>
            </div>
            <div>{{ $t('modal.idp_export_competencies') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="skills" @change="checkRows($event, 'skills')"/>
            </div>
            <div>{{ $t('modal.idp_export_skills') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="format" @change="checkRows($event, 'format')"/>
            </div>
            <div>{{ $t('modal.idp_export_format') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="type" @change="checkRows($event, 'type')"/>
            </div>
            <div>{{ $t('modal.idp_export_type') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="resource" @change="checkRows($event, 'resource')"/>
            </div>
            <div>{{ $t('modal.idp_export_resource') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="method" @change="checkRows($event, 'method')"/>
            </div>
            <div>{{ $t('modal.idp_export_method') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="eventName" @change="checkRows($event, 'eventName')"/>
            </div>
            <div>{{ $t('modal.idp_export_event_name') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="provider" @change="checkRows($event, 'provider')"/>
            </div>
            <div>{{ $t('modal.idp_export_provider') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="trainer" @change="checkRows($event, 'trainer')"/>
            </div>
            <div>{{ $t('modal.idp_export_trainer') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="duration" @change="checkRows($event, 'duration')"/>
            </div>
            <div>{{ $t('modal.idp_export_duration') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="courseDescription" @change="checkRows($event, 'courseDescription')"/>
            </div>
            <div>{{ $t('modal.idp_export_course_description') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="targetGroup" @change="checkRows($event, 'targetGroup')"/>
            </div>
            <div>{{ $t('modal.idp_export_target_group') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="program" @change="checkRows($event, 'program')"/>
            </div>
            <div>{{ $t('modal.idp_export_program') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="learningMaterials" @change="checkRows($event, 'learningMaterials')"/>
            </div>
            <div>{{ $t('modal.idp_export_learning_materials') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="period" @change="checkRows($event, 'period')"/>
            </div>
            <div>{{ $t('modal.idp_export_period') }}</div>
          </div>
          <div class="d-flex">
            <div style="padding-top: 11px">
              <b-form-checkbox v-model="exportStatus" @change="checkRows($event, 'exportStatus')"/>
            </div>
            <div>{{ $t('modal.idp_export_status') }}</div>
          </div>
        </div>
      </div>

    </template>
    <template #modal-footer>
      <button id="save" class="btn btn-primary adp-btn adp-btn__large" style="margin-left: auto"
              @click="download()" :disabled="selectedYears.length === 0 || !pernumber || (!learning && !wish)">
        {{ $t('modal.idp_export_download') }}
      </button>
    </template>
  </b-modal>
</template>

<script>
import api from "../../../api";
import MyDropdown from "../../MyDropdown";

export default {
  name: "MassIdpExportModal",
  props: {
    pernumbers: {
      type: Array,
      required: true,
    },
    exportType: {
      type: String,
      required: true,
    }
  },
  components: {MyDropdown},
  data: function () {
    return {
      isLoading: false,
      modalTitle: '',

      selectedYears: [],

      allTypes: true,
      allTypesIndeterminate: false,
      learning: true,
      wish: true,

      allRows: true,
      allRowsIndeterminate: false,
      pernumber: true,
      fio: true,
      position: true,
      employeeType: true,
      reservist: true,
      employeeGroup: true,
      sex: true,
      bu: true,
      division: true,
      subdivision: true,
      department: true,
      orgStructure5: true,
      orgStructure6: true,
      orgStructure7: true,
      orgStructure8: true,
      fired: true,
      supervisor: true,
      idpYear: true,
      idpStatus: true,
      idpPercent: true,
      learningGroup: true,
      func: true,
      competencies: true,
      skills: true,
      format: true,
      type: true,
      resource: true,
      method: true,
      eventName: true,
      provider: true,
      trainer: true,
      duration: true,
      courseDescription: true,
      targetGroup: true,
      program: true,
      learningMaterials: true,
      period: true,
      exportStatus: true,
    }
  },
  computed: {
    IDPYears() {
      const currentYear = new Date().getFullYear();
      let year = 2021;
      let years = [year];

      while (year !== currentYear) {
        year++;
        years.push(year);
      }

      return [...years, currentYear+1, currentYear+2, currentYear+3].map(x => ({code: x, id: x}));
    },
    checkedTypesCount() {
      return [this.wish, this.learning].filter(x => x).length
    },
    checkedRowsCount() {
      return [
        this.pernumber, this.fio, this.position, this.employeeType, this.reservist,
        this.employeeGroup, this.sex, this.bu, this.division, this.subdivision, this.department,
        this.orgStructure5, this.orgStructure6, this.orgStructure7, this.orgStructure8, this.supervisor,
        this.idpYear, this.idpStatus, this.idpPercent, this.learningGroup, this.func, this.competencies,
        this.skills, this.format, this.type, this.resource, this.method, this.eventName, this.provider,
        this.trainer, this.duration, this.courseDescription, this.targetGroup, this.program, this.learningMaterials,
        this.period, this.exportStatus, this.fired
      ].filter(x => x).length
    },
  },
  watch: {
  },
  methods: {
    onShow() {
      this.selectedYears = [new Date().getFullYear()];
      this.allTypes = true;
      this.learning = true;
      this.wish = true;
      this.allRows = true;
      this.pernumber = true;
      this.fio = true;
      this.position = true;
      this.employeeType = true;
      this.reservist = true;
      this.employeeGroup = true;
      this.sex = true;
      this.bu = true;
      this.division = true;
      this.subdivision = true;
      this.department = true;
      this.orgStructure5 = true;
      this.orgStructure6 = true;
      this.orgStructure7 = true;
      this.orgStructure8 = true;
      this.fired = true;
      this.supervisor = true;
      this.idpYear = true;
      this.idpStatus = true;
      this.idpPercent = true;
      this.learningGroup = true;
      this.func = true;
      this.competencies = true;
      this.skills = true;
      this.format = true;
      this.type = true;
      this.resource = true;
      this.method = true;
      this.eventName = true;
      this.provider = true;
      this.trainer = true;
      this.duration = true;
      this.courseDescription = true;
      this.targetGroup = true;
      this.program = true;
      this.learningMaterials = true;
      this.period = true;
      this.exportStatus = true;

      this.modalTitle = this.$t('modal.idp_export');

      if (this.exportType === 'wish') {
        this.allTypes = false;
        this.learning = false;
        this.modalTitle = this.$t('modal.wish_export');
      }
    },
    changeYear(e, property) {
      this[property] = e;
    },
    checkAllTypes(e) {
      if (!this.allTypesIndeterminate) {
        this.allTypes = e;
      }
      if (this.allTypes) {
        this.wish = true;
        this.learning = true;
      }
      if (!this.allTypes || this.allTypesIndeterminate) {
        this.wish = false;
        this.learning = false;
        this.allTypes = false;
      }

      this.allTypesIndeterminate = false;
    },
    checkTypes(e, property) {
      this[property] = e;
      if (this.checkedTypesCount === 0) {
        this.allTypesIndeterminate = false;
        this.allTypes = false;
      } else if (this.checkedTypesCount === 2) {
        this.allTypesIndeterminate = false;
        this.allTypes = true;
      } else {
        this.allTypes = false;
        this.allTypesIndeterminate = true;
      }
    },
    checkAllRows(e) {
      if (!this.allRowsIndeterminate) {
        this.allRows = e;
      }
      if (this.allRows) {
        this.pernumber = true;
        this.fio = true;
        this.position = true;
        this.employeeType = true;
        this.reservist = true;
        this.employeeGroup = true;
        this.sex = true;
        this.bu = true;
        this.division = true;
        this.subdivision = true;
        this.department = true;
        this.orgStructure5 = true;
        this.orgStructure6 = true;
        this.orgStructure7 = true;
        this.orgStructure8 = true;
        this.fired = true;
        this.supervisor = true;
        this.idpYear = true;
        this.idpStatus = true;
        this.idpPercent = true;
        this.learningGroup = true;
        this.func = true;
        this.competencies = true;
        this.skills = true;
        this.format = true;
        this.type = true;
        this.resource = true;
        this.method = true;
        this.eventName = true;
        this.provider = true;
        this.trainer = true;
        this.duration = true;
        this.courseDescription = true;
        this.targetGroup = true;
        this.program = true;
        this.learningMaterials = true;
        this.period = true;
        this.exportStatus = true;
      }
      if (!this.allRows || this.allRowsIndeterminate) {
        this.pernumber = false;
        this.fio = false;
        this.position = false;
        this.employeeType = false;
        this.reservist = false;
        this.employeeGroup = false;
        this.sex = false;
        this.bu = false;
        this.division = false;
        this.subdivision = false;
        this.department = false;
        this.orgStructure5 = false;
        this.orgStructure6 = false;
        this.orgStructure7 = false;
        this.orgStructure8 = false;
        this.fired = false;
        this.supervisor = false;
        this.idpYear = false;
        this.idpStatus = false;
        this.idpPercent = false;
        this.learningGroup = false;
        this.func = false;
        this.competencies = false;
        this.skills = false;
        this.format = false;
        this.type = false;
        this.resource = false;
        this.method = false;
        this.eventName = false;
        this.provider = false;
        this.trainer = false;
        this.duration = false;
        this.courseDescription = false;
        this.targetGroup = false;
        this.program = false;
        this.learningMaterials = false;
        this.period = false;
        this.exportStatus = false;
        this.allRows = false;
      }

      this.allRowsIndeterminate = false;
    },
    checkRows(e, property) {
      this[property] = e;
      if (this.checkedRowsCount === 0) {
        this.allRowsIndeterminate = false;
        this.allRows = false;
      } else if (this.checkedRowsCount === 37) {
        this.allRowsIndeterminate = false;
        this.allRows = true;
      } else {
        this.allRows = false;
        this.allRowsIndeterminate = true;
      }
    },
    async download() {
      const data = {
        'pernumbers': this.pernumbers,
        'selectedYears': this.selectedYears,
        'learning': this.learning,
        'wish': this.wish,
        'pernumber': this.pernumber,
        'fio': this.fio,
        'position': this.position,
        'employeeType': this.employeeType,
        'reservist': this.reservist,
        'employeeGroup': this.employeeGroup,
        'sex': this.sex,
        'bu': this.bu,
        'division': this.division,
        'subdivision': this.subdivision,
        'department': this.department,
        'orgStructure5': this.orgStructure5,
        'orgStructure6': this.orgStructure6,
        'orgStructure7': this.orgStructure7,
        'orgStructure8': this.orgStructure8,
        'fired': this.fired,
        'supervisor': this.supervisor,
        'idpYear': this.idpYear,
        'idpStatus': this.idpStatus,
        'idpPercent': this.idpPercent,
        'learningGroup': this.learningGroup,
        'func': this.func,
        'competencies': this.competencies,
        'skills': this.skills,
        'format': this.format,
        'type': this.type,
        'resource': this.resource,
        'method': this.method,
        'eventName': this.eventName,
        'provider': this.provider,
        'trainer': this.trainer,
        'duration': this.duration,
        'courseDescription': this.courseDescription,
        'targetGroup': this.targetGroup,
        'program': this.program,
        'learningMaterials': this.learningMaterials,
        'period': this.period,
        'exportStatus': this.exportStatus,
      };

      await api.export(data)
        .then(() => this.$bvModal.hide('mass-idp-export-modal'))
        .then(() => {
          let reportsIcon = document.getElementById('reports-download')
          let loadingIcon = document.getElementById('reports-download-circle')
          reportsIcon.hidden = true
          loadingIcon.hidden = false
        });
    }
  },
  async mounted() {

  }
}
</script>
